import { grScope } from "../../../common/logger";
import { on, unsetAll } from "../../../exports/event";
import type { Unset } from "../../event/head";

const log = grScope.scope("apm.errors");
const { apm, dom } = otto;

/**
 *
 *
 *
 */
export const initErrorHandling = (): Unset =>
  dom.onReady.subscribe(
    /*                                                   */
    /*                                                      */
    unsetAll(
      /*                                        */
      on(window, "error", (event) => {
        if (!event.error) return;
        log.info("Handle error on page load", event.error);
        apm.captureError(event.error, { team: "unknown", service: "unknown" });
      }),
      /*                                         */
      on(window, "unhandledrejection", (event) => {
        if (!event.reason) return;
        log.info("Handle unhandled rejection on page load", event.reason);
        apm.captureError(event.reason, { team: "unknown", service: "unknown" });
      }),
    ),
  );
